import * as yup from 'yup';

export const yupCurrencySchema = yup.object().shape({
  name: yup.string(),
  exchangeRate: yup.number(),
});
